import { render, staticRenderFns } from "./WagesAgreementContents.vue?vue&type=template&id=4ead9a9e&scoped=true&"
import script from "./WagesAgreementContents.vue?vue&type=script&lang=js&"
export * from "./WagesAgreementContents.vue?vue&type=script&lang=js&"
import style0 from "./WagesAgreementContents.vue?vue&type=style&index=0&id=4ead9a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead9a9e",
  null
  
)

export default component.exports